export default "__VITE_ASSET__CKHzhieb__"